import { render, staticRenderFns } from "./TopicPostsComponent.vue?vue&type=template&id=0a783e74&"
import script from "./TopicPostsComponent.vue?vue&type=script&lang=js&"
export * from "./TopicPostsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports